import { Alert, Card, Image, Stack, Text, Title } from "@mantine/core";
import { IconInfoCircle } from "@tabler/icons-react";
import Diagram from "../../../../assets/EventsStatusFlow.svg";
import { PageHeader } from "../../components/PageHeader";

export const EventHome = () => {
  return (
    <div className="wp-fade-in">
      <PageHeader
        title="Events"
        subtitle="Create and manage events, venues and ticketing systems"
        showBreadcrumbs={false}
      />
      <Stack gap="lg">
        <Text>
          The Events feature allows you to create and manage events, venues and
          ticketing systems. This system has been designed to be as flexible as
          possible, allowing you to create events for any kind of occasion, from
          tournaments to concerts.
        </Text>

        <Alert icon={<IconInfoCircle />} color="indigo" variant="light">
          By combining the Events feature with the Platform feature, you can
          create your own customized website to sell tickets, manage your events
          and more!
        </Alert>

        <Card withBorder p="lg" radius="md">
          <Title order={3} mb="sm">
            Reservation Status Flow
          </Title>
          <Text size="sm" c="dimmed" mb="md">
            The following diagram shows the possible reservation statuses
            depending on the user actions and event configuration:
          </Text>
          <Image src={Diagram} alt="Event status flow" />
        </Card>

        <Title order={3}>Manage Reservations</Title>
        <Text>
          The reservation system manages user registrations. When a user
          registers to an event, a reservation is created containing all
          information about the user and the tickets purchased.
        </Text>

        <Title order={3}>Reservation Rules</Title>
        <Text>
          Reservation rules provide flexible requirements that users must meet
          to create a reservation. Requirements can range from user profile
          properties to having specific external accounts linked. For example,
          you can require that a player has a valid Discord account linked.
        </Text>

        <Title order={3}>Ticket Configurations</Title>
        <Text>
          Configure the tickets available for an event: price, quantity, type,
          and seat assignments. Tickets can be linked to specific seats or areas
          of a venue.
        </Text>

        <Title order={3}>Groups</Title>
        <Text>
          Groups allow users to invite others to their reservation and assign
          them tickets. This is useful for team events or group bookings. Groups
          can also be combined with reservation rules to validate all members.
        </Text>

        <Title order={3}>Custom Fields</Title>
        <Text>
          Add custom fields to the registration form to collect additional
          information. Custom fields can be linked to reservations or group
          members and used in reservation rules for validation.
        </Text>

        <Title order={3}>Venues</Title>
        <Text>
          Create venues with seating plans, assign tickets to specific seats or
          areas, and allow users to select their seats. An editor is provided to
          create sections, rows, and seats. Venue configurations can be made
          public for reuse by other event creators.
        </Text>
      </Stack>
    </div>
  );
};
